<template>
  <div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full sm:w-1 lg:w-1/2">
          Class:
          <h5>
          <span v-for="(v) in content.class" :key="v.class_id">
            <span class="mb-2">{{ classes[v.class_id] }} . </span>
          </span>
          </h5>

          Category: <h5 class="mb-1">{{ category[content.cat_id] }}</h5>
        </div>
        <div class="vx-col w-full sm:w-1 lg:w-1/2">
          Subject: <h5 class="mb-2">{{ subjects[content.subj_id] }}</h5>
          Title: <h5 class="mb-0">{{ content.title }}</h5>
        </div>
      </div>

      <div class="vx-row" v-if="editmode">
        <vs-divider></vs-divider>

        <div class="vx-col sm:w-1/3 w-full mb-2">
          <v-select :options="data.subject" v-model="selectedSubject" label="label" placeholder="Change Class Subject"  />
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <v-select :options="data.category" v-model="group.category" placeholder="Change Category"  />
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-input class="w-full" v-model="group.title" placeholder="Change Title" />
        </div>
      </div>

      <br>

      <div v-show="selectedSubject">
        <p class="mb-5">Change Classes taking this lesson</p>

        <div class="vx-row ml-0 mr-0" v-show="selectedSubject && selectedSubject.subj_id == key" v-for="(value, key) in data.classes" :key="key">
          <div class="vx-col sm:w-1/6 w-full mb-2" v-for="(val, ky) in value" :key="ky">
            <ul v-for="(v, k) in val" :key="k">
              <li>
                <vs-checkbox :vs-value="v.class_id" v-model="group.class">{{ v.class }}</vs-checkbox>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </vx-card>

    <br><br>

    <div class="vx-row">
      <div class="vx-col w-full sm:w-1 lg:w-2/3 mb-base">
        <vx-card title="Images" collapse-action>
          <div class="carousel-example">
            <!-- swiper -->
            <swiper :options="swiperOption" ref="mySwiper" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
              <!-- manual slides -->

              <swiper-slide v-for="(asset, id) in content.assets.image" :key="id">
                <img class="" :src="asset.link" alt="Image" height="100px">
              </swiper-slide>

              <!-- nav buttons -->
              <div class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </vx-card>
        

        <div v-if="assets.videoID">
          <br><br>
          
          <vx-card class="overflow-hidden" :key="assets.videoID">
            <template slot="no-body">
              <video-player ref="player" class="media-video-player card-video" :options="assets.videolinkOption" />
            </template>
          </vx-card>
        </div>
        

        <br><br>

        <vx-card title="Note">
          <quill-editor v-if="editmode" v-model="group.content"></quill-editor>
          <div v-else id="classnote" v-html="content.text"></div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
        <vx-card>
          <div class="my-0">
            <h5 class="mb-1">Lesson Controls</h5>
            <p class="text-grey">Modify lesson</p>
          </div>
          <vs-divider></vs-divider>
          <table border="0" width="100%" class="lesson-info">
            <tr><td>Published<br></td><td><vs-switch v-model="statePublished" /></td></tr>
            <tr><td>Featured</td><td><vs-switch color="warning" v-model="stateFeatured" /></td></tr>
            <tr><td>Created</td><td>{{ content.createdAt | moment("MMM Do, YYYY HH:MM") }}</td></tr>
          </table>
          <vs-divider></vs-divider>
          <div v-if="!editmode">
            <vs-button color="primary" class="mr-5" @click="editmode = !editmode">Edit Lesson</vs-button>
            <vs-button color="danger" v-on:click="openDelConfirm()">Delete</vs-button>
          </div>
          <div v-else>
            <vs-button color="success" class="mr-5" @click="UpdateLesson()">Save Changes</vs-button>
            <vs-button color="danger" @click="editmode = !editmode">Cancel</vs-button>
            <!-- <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash"></vs-button> -->
          </div>
          
        </vx-card>

        <br><br>

        <vx-card>
          <div class="my-0">
            <h5 class="mb-1">Assets</h5>
            <p class="text-grey">Lesson videos or extras</p>
          </div>
          <vs-divider></vs-divider>
            <ul class="page-suggestions-list">
              <li class="page-suggestion flex items-center mb-4" v-for="(asset) in content.assets.image" :key="asset.key">
                <div class="mr-3"><vs-avatar text="IMAGE"/></div>
                  <div class="leading-tight pointer">
                    <p class="font-medium elip" v-bind:class="{ 'text-danger': (deleteAsset[asset.key])}">{{ asset.name }}</p>
                    <span class="text-xs">Image</span>
                  </div>
                  <div v-if="editmode"><vs-button radius @click="markForDelete(asset.key)" size="large" color="danger" type="flat" icon-pack="feather" icon="icon-x"></vs-button></div>
              </li>

              <li class="page-suggestion flex items-center mb-4" v-for="(asset) in content.assets.video" :key="asset.key">
                  <div class="mr-3"><vs-avatar text="VIDEO"/></div>
                  <div class="leading-tight pointer" @click="updateVideoID(asset)">
                    <p class="font-medium elip" v-bind:class="{ 'text-danger': (deleteAsset[asset.key])}">{{ asset.name }}</p>
                    <span class="text-xs">Video</span>
                  </div>
                  <div v-if="editmode"><vs-button radius @click="markForDelete(asset.key)" size="large" color="danger" type="flat" icon-pack="feather" icon="icon-x"></vs-button></div>
              </li>
            </ul>
          <vs-divider></vs-divider>
          <vs-button color="primary" type="filled" @click="openUpload">Add Image/Video</vs-button>
          <vs-divider></vs-divider>
        </vx-card>
      </div>
    </div>


    <vs-popup class="holamundo" title="Upload Asset" :active.sync="uploadImagePopup">
      <vs-row vs-w="12" class="mb-10">
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
      </vs-row>

      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="10">
          <vs-progress :height="12" :percent="upload.percentage" color="success"></vs-progress>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
          <div class="demo-alignment">
            {{ upload.percentage }} %
          </div>
        </vs-col>
      </vs-row>

      <vs-button class="mr-3 mb-2" @click="submitFile()">Upload</vs-button>
    </vs-popup>


    <div id="demo-basic-card">
      <div class="vx-row">
        
      </div>
    </div>

  </div>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'video.js/dist/video-js.css'
import vSelect from 'vue-select'

import { quillEditor } from 'vue-quill-editor'
import { videoPlayer }     from 'vue-video-player'
import Prism from 'vue-prism-component'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  data () {
    return {
      editmode: false,
      selectedSubject: null,
      group: {
        class: [],
        subject: null,
        category: null,
        title:null,
        content: null
      },
      deleteAsset: {},
      data: {
        subject: [],
        category: [],
        classes: {}
      },
      assets: {
        videoID: null,
        imagelink: null,
        videolinkOption: {}
      },
      uploadImagePopup: false,
      upload: {
        file: '',
        percentage: 0
      },
      content: null,
      category: {},
      subjects: {},
      classes: {},
      statePublished: null,
      stateFeatured: null,
      swiperOption: {
        slidesPerView: 3,
        centeredSlides: true,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        }
      }
    }
  },
  components: {
    quillEditor,
    videoPlayer,
    Prism,
    vSelect,
    swiper,
    swiperSlide
  },
  computed: {

  },

  watch: {
    selectedSubject: function (newValue, oldValue) {
      this.group.class = [];
    },

    statePublished: function (newValue, oldValue) {
      if (oldValue !== null) {
        if (newValue === false) {
          this.stateFeatured = false;
        }

        this.$http.put(`/lms/st/lesson/content/${this.$route.params.id}`, { published: newValue }).then((response) => {
          if (response && response.data && response.data.data) {
            return this.$vs.notify({ color: 'success', title: 'Lesson Updated', text: 'Lesson marked as Published' })
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },

    stateFeatured: function (newValue, oldValue) {
      if (oldValue !== null) {
        if (newValue === true) {
          this.statePublished = true;
        }

        this.$http.put(`/lms/st/lesson/content/${this.$route.params.id}`, { featured: newValue }).then((response) => {
          if (response && response.data && response.data.data) {
            return this.$vs.notify({ color: 'success', title: 'Lesson Updated', text: 'Lesson marked as Featured' })
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    }
  },

  created () {
    // this.$http.get('/lms/st/academics/subject/assigned').then((response) => {
    //   if (response && response.data && response.data.data) {
    //     response.data.data.forEach((v) => {
    //       this.classes[v.class_id] = v.class_name
    //       this.subjects[v.subj_id] = v.name
    //       this.data.subject.push({ subj_id: v.subj_id, class_id: v.class_id, subj: v.subj_short, class: v.class_short, label: `${v.class_short} - ${v.name}` })
    //     })
    //   }
    // }).catch((error) => { 
    //   console.log(error)
    // })

    this.$http.get('/lms/st/academics/subject/assigned').then((response) => {
      if (response && response.data && response.data.data) {
        const tracker = { subj: {}, class: {} }

        response.data.data.forEach((v) => {
          this.classes[v.class_id] = v.class_name
          this.subjects[v.subj_id] = v.name

          if (!tracker.subj[v.subj_id]) {
            this.data.subject.push({ subj_id: v.subj_id, class_id: v.class_id, subj: v.subj_short, class: v.class_short, label: `${v.name}` })
          }

          if (!tracker.class[`${v.class_id}-${v.subj_id}`]) {
            const rank = v.rank.toString().slice(0, 2)
            this.data.classes[v.subj_id] = this.data.classes[v.subj_id] || {}
            this.data.classes[v.subj_id][rank] = this.data.classes[v.subj_id][rank] || []
            this.data.classes[v.subj_id][rank].push({ class: v.class_name, subj: v.subj_id, class_id: v.class_id })
          }

          tracker.class[v.class_id] = 1
          tracker.subj[v.subj_id] = 1
        })
      }

      console.log('----', this.classes)
    }).catch((error) => { 
      console.log(error)
    })

    this.$http.get('/lms/st/lesson/category').then((response) => {
      if (response && response.data && response.data.data) {
        response.data.data.forEach((v) => {
          this.category[v.id] = v.name
          this.data.category.push({ id: v.id, label: v.name })
        })
      }
    }).catch((error) => { 
      console.log(error)
    })

    this.getLessonContent()
    
  },
  methods: {
    openDelConfirm () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Do you really want to delete this Lesson.',
        accept: this.deleteMessage
      })
    },
    getLessonContent () {
      this.$http.get(`/lms/st/lesson/content/${this.$route.params.id}`).then((response) => {
        if (response && response.data && response.data.data) {
          this.content = response.data.data
          this.statePublished = response.data.data.published || false
          this.stateFeatured = response.data.data.featured || false
          this.group.content = response.data.data.text
        }
      }).catch((error) => { 
        console.log(error)
      })
    },

    deleteMessage () {
      this.$vs.loading()
      this.$http.delete(`/lms/st/lesson/content/${this.content.id}`).then((response) => {
        this.$vs.loading.close()
        if (response && response.data && response.data.data) {
          this.$vs.notify({ color: 'success', title: 'Lesson Deleted', text: 'Lesson has been deleted successfully' })
          this.$router.push('/lesson/personal')
        }
        this.fetchMessages()
      }).catch((error) => { 
        console.log(error)
      })
    },

    updateVideoID (asset) {
      const videoAssets = {
        height: '240',
        fluid: true,
        autoplay: true,
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{ type: 'video/mp4', src: asset.link }]
      }

      this.assets.videolinkOption = videoAssets
      this.assets.videoID = asset.name
    },

    updateVideoLink (link) {
      this.assets.videolinkOption.sources.src = link
    },

    markForDelete (assetId) {
      console.log('action on this', assetId)
      const tracker = {...this.deleteAsset}

      if (tracker[assetId]) delete tracker[assetId]
      else tracker[assetId] = assetId

      this.deleteAsset = {...tracker}
    },

    openUpload () {
      this.uploadImagePopup = true
      // this.upload.file = null -- not working
      this.upload.percentage = 0
    },

    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      console.log(this.file)
    },

    submitFile () {
      if (!(this.file && this.file.name)) {
        return this.$vs.notify({ color: 'danger', title: 'No File Selected', text: 'Please select a file to Upload' })
      }

      const formData = new FormData()
      let linkId = null

      const requestPayload = {
        service: 'lesson',
        serviceid: this.content.id,
        filename: this.file.name,
        filetype: this.file.type,
        filesize: this.file.size
      }

      this.$http.post('/lms/st/asset/upload', requestPayload).then((response) => {
        let pushFile = false

        if (response && response.data && response.data.data) {
          if (response.data.data.link === 'MERGE') {
            this.upload.percentage = 100
          } else {
            linkId = response.data.data.id

            for (const field in response.data.data.link.fields) {
              formData.append(field, response.data.data.link.fields[field])
            }
            formData.append('file', this.file)

            pushFile = this.$http.post(response.data.data.link.url, formData, {
              headers: { 'Content-Type': 'multipart/form-data', 'X-NOINIT': true },
              onUploadProgress: function (progressEvent) {
                this.upload.percentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
              }.bind(this)
            })
          }

        } else {
          return this.$vs.notify({ color: 'danger', title: 'Upload Failed', text: 'Unable to upload at this time.' })
        }

        return pushFile
      }).then(() => {
        this.uploadImagePopup = false
        if (linkId) {
          this.$http.post('/lms/st/asset/verify', { ...requestPayload, id: linkId})
        }
        this.getLessonContent()
      }).catch((error) => { 
        console.log('HTTP ERROR', error.response.data)
        let text = 'Upload failed, try another file.'

        if (error && error.response && error.response.data && error.response.data) {
          text = error.response.data.message
        }

        return this.$vs.notify({ color: 'danger', title: 'Upload Request Failed', text })
      })
    },

    
    successUpload () {
      this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'Lorem ipsum dolor sit amet, consectetur' })
    },
    UpdateLesson () {
      const payload = {}

      if (this.selectedSubject && this.group.class.length) {
        payload.class = this.group.class
        payload.subj_id = this.selectedSubject.subj_id
        payload.slug = `${this.selectedSubject.subj}`
      }

      if (this.group.title) payload.title = this.group.title
      if (this.group.category) payload.category = this.group.category.id

      if (this.group.content !== this.content.text) payload.text = this.group.content

      if (Object.keys(this.deleteAsset).length) payload.delete_asset = this.deleteAsset

      if (Object.keys(payload).length) {
        this.$vs.loading()
        this.$http.put(`/lms/st/lesson/content/${this.content.id}`, payload).then((response) => {
          this.$vs.loading.close()
          if (response && response.data && response.data.data) {
            this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'Lesson Updated' })
            this.$router.go()
          }
        }).catch((error) => { 
          this.$vs.loading.close()
          this.$router.go()
          console.log(error)
        })
      } else {
        this.editmode = false
        // this.$router.go()
      }
    }
  }
}
</script>


<style scoped>

table.lesson-info {
  line-height: 40px;
}

</style>

<style lang="scss" scoped>
.swiper-container {
  ::v-deep .swiper-slide {
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    background-color: #eee;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    min-height: 150px;

    .theme-dark & {
      background-color: #242a47;
    }
  }
}

#demo-basic-card {
  .overlay-card {
    .vx-card__collapsible-content {
        max-height: 485px;
    }
  }

  .chat-card-log {
    height: 360px;

    .chat-sent-msg {
        background-color: #f2f4f7 !important;
    }
  }

  .card-video {
    .video-js {
        height: 370px;
    }
  }
}

.pointer {
  cursor: pointer;
}

.elip {
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // display: inline-block;
  max-width: 100%;
}

#classnote {
  // border: 2px solid pink;
  // width: 50;
}

#classnote img {
  border: 2px solid blue !important;
  // width: 50;
}
</style>